export default "__VITE_ASSET__CTxExdXN__"